import { render } from "./Tabs.vue?vue&type=template&id=65078d53&scoped=true&ts=true"
import script from "./Tabs.vue?vue&type=script&lang=ts"
export * from "./Tabs.vue?vue&type=script&lang=ts"

import "./Tabs.vue?vue&type=style&index=0&id=65078d53&lang=scss&scoped=true"

import exportComponent from "E:\\vue_test\\vue-gpt-sample\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65078d53"]])

export default __exports__